import { BASE, NESTED_ROUTES } from './BaseRoutes';
import { generateNestedRoute } from './helpers';

export const GENERATED_ROUTES = {
  ADMINISTRATION: {
    ACCOUNTS: generateNestedRoute(
      BASE.ADMINISTRATION,
      NESTED_ROUTES.ADMINISTRATION.ACCOUNTS,
    ),
    BILLS: generateNestedRoute(
      BASE.ADMINISTRATION,
      NESTED_ROUTES.ADMINISTRATION.BILLS,
    ),
    METERS: generateNestedRoute(
      BASE.ADMINISTRATION,
      NESTED_ROUTES.ADMINISTRATION.METERS,
    ),
  },
  SUMMARY: {
    DATA_INSIGHTS: generateNestedRoute(
      BASE.SUMMARY,
      NESTED_ROUTES.SUMMARY.DATA_INSIGHTS,
    ),
  },
};
